<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    filled
    dense
  ></v-select>
</template>

<script>

  export default {
    name: 'DayMonthYear',
    data: () => ({
      items: [
        {
          text: 'Days',
          value: 'days',
        },
        {
          text: 'Months',
          value: 'months',
        },
        {
          text: 'Years',
          value: 'years',
        },
      ],
    }),
  }
</script>

<style scoped>

</style>
